import { render } from "./StyledInput.vue?vue&type=template&id=773aa708&bindings={\"label\":\"props\",\"type\":\"props\",\"placeholder\":\"props\",\"value\":\"props\"}"
import script from "./StyledInput.vue?vue&type=script&lang=js"
export * from "./StyledInput.vue?vue&type=script&lang=js"

import "./StyledInput.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script